module.exports = {
  CREATED: 'created',
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  CANCELED: 'cancelled',
  UNKNOWN: 'unknown',
};
